var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 200 200",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M100 154a13.375 13.375 0 0 1-9.241-3.699l-85.075-81C.302 64.175.074 55.63 5.174 50.21c5.104-5.408 13.603-5.638 18.99-.512L100 121.906l75.833-72.207c5.391-5.126 13.894-4.896 18.994.513 5.1 5.418 4.872 13.963-.514 19.089l-85.075 81A13.358 13.358 0 0 1 100 154Z"
})));
export default SvgChevron;